export const disabled = () => {
    const inputs = document.querySelectorAll('.otp-input');
    inputs.forEach(input => {
        input.disabled = true;
    });

};

export const enabled = () => {
    console.log("A");
    const inputs = document.querySelectorAll('.otp-input');
    inputs.forEach(input => {
        input.disabled = false;
        input.value = "";
    });

};